var csrfSelectors = require('../utils/constants').csrfSelectors;

function getCsrfFromDom(action) {
    var csrfTag = document.getElementsByClassName('csrf-ajax-' + csrfSelectors[action]);
    var srtTags = [];
    if (csrfTag.length > 0) {
        srtTags = csrfTag[0].getElementsByTagName('INPUT');
    }
    return srtTags.length > 0 ? srtTags[0].getAttribute('value') : '';
}

module.exports = getCsrfFromDom;
